import styled from 'styled-components/macro';

import CardBase from '@components/common/core/Surfaces/Card';
import TextBase from '@components/common/core/DataDisplay/Text';

export const SyncContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Text = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray[2]};
  text-align: center;
  line-height: 120%;
  max-width: 146px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & > svg {
    min-width: 40px;
  }
`;

export const CardWrapper = styled(CardBase)`
  padding: 20px 18px;
  box-sizing: border-box;
  min-width: 264px;
  height: 96px;
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 12px;
  border: unset;
  cursor: default;
  width: 100%;
  display: flex;
  align-items: center;
`;
